import { FC } from 'react'
import { Modal, Spinner } from 'reactstrap';
interface IProps {
    show: boolean;
    loading: boolean;
    title: string;
    content: string;
    onCancel: (value: boolean) => void;
    onDelete: () => void;
}

export const DeleteModalv2: FC<IProps> = ({
    show,
    loading,
    title,
    content,
    onCancel, 
    onDelete
}) => {
  return (
    <Modal
        isOpen={show}
        backdrop={"static"}
        id="staticBackdrop"
    >
        <div className="modal-header bg-danger-light">
            <h5 className="modal-title" id="staticBackdropLabel">
                {title}
            </h5>
        </div>
        <div className="modal-body">
            <p>
            {content}
            </p>
        </div>
        <div className="modal-footer">
            <button
                type="button"
                className="btn btn-light"
                onClick={() => onCancel(false)}
            >
                Cancel
            </button>
            <button 
                type="button" 
                className="btn btn-primary fw-semibold"
                onClick={() => loading ? null : onDelete()}
            >
                {
                loading ? (
                    <div className='d-flex align-items-center'>
                        <Spinner size="sm" color="light" />
                        <span className="text-white mx-2">Deleting...</span>
                    </div>
                    
                ) : (
                    <span className="">Yes, delete</span>
                )}
            </button>
        </div>
    </Modal>
  )
}
